import React from 'react';

import S360WidgetBlock from "root/s360components/LearningJournal/S360WidgetBlock";
import DropdownProviderEYFSGroups from "root/ReactHookForm/ui/DropdownProviderEYFSGroups";
import DropdownProviderEYFSGroupMembers from "root/ReactHookForm/ui/DropdownProviderEYFSGroupMembers";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";

import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {SmartErrorDiv} from "root/ReactHookForm/FormComponents";
import {FormSectionNames} from "root/s360components/LearningJournal/LearningJournalPage";

export const groupAndChild = () =>
{
    return {
        [FormSectionNames.GROUP_AND_CHILD]:
            {
                eyfs_group_id: null,
                child_id: null,
            }
    }
}

const HookSubFormGroupAndPupil = ({school_id, control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const [ groupId ] = useWatchDropdown( {control, name: sectionName + '.' + 'eyfs_group_id', isInt: false, namedField: 'group_id' }) ;

    const validateGroup = (val) =>
    {
        if (val === null)
        {
            return "Please Select a Group/Class.";
        }
    }

    const validateChild = (val) =>
    {
        if (val === null)
        {
            return "Please Select a Pupil.";
        }
    }

    return (
        <S360WidgetBlock title=''>
            <BootstrapRow>
                <BootstrapCol width={6}>
                    <h5>Select a Group/Class</h5>
                    <DropdownProviderEYFSGroups school_id={school_id} name={sectionName + '.eyfs_group_id'}
                                                control={control} rules={{validate: validateGroup}}
                                                placeHolder='Pick a Group' readOnly={readOnly} />
                    <SmartErrorDiv sectionName={sectionName} name={'eyfs_group_id'} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={6}>
                    <h5>Select a Pupil</h5>
                    <DropdownProviderEYFSGroupMembers enc_group_id={groupId} name={sectionName + '.child_id'}
                                                      control={control} rules={{validate: validateChild}}
                                                      placeHolder='Pick a Child' readOnly={groupId === null} />
                    <SmartErrorDiv sectionName={sectionName} name={'child_id'} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow>
        </S360WidgetBlock>
    )
}


export default HookSubFormGroupAndPupil;
